export default __webpack_public_path__ + "static/media/tuqTacToe.1ad370df.gif";